export default __webpack_public_path__ + "static/media/Bullet 01.1a2b2928.webp";